import { useCallback } from 'react';

import useStateMountSafe from '@/hooks/useStateMountSafe';
import { Func } from '@/utils/ts';

export default function useSubmitting(
  initialValue: boolean,
): [boolean, <V extends any[], R>(func: Func<V, R>) => Func<V, R>, () => void, () => void] {
  const [submitting, setSubmitting] = useStateMountSafe(initialValue);
  const reset = () => setSubmitting(initialValue);
  const withSubmitting = useCallback(
    <V extends any[], R>(func: Func<V, R>) => async (...params: V) => {
      setSubmitting(true);
      try {
        return await func(...params);
      } finally {
        setSubmitting(false);
      }
    },
    [setSubmitting],
  );
  const markSubmitting = useCallback(() => setSubmitting(true), [setSubmitting]);

  return [submitting, withSubmitting, reset, markSubmitting];
}
